import {
    SUCCESSFUL_GET_QUOTASTOPAY,
    UPDATE_QUOTAS_SELECTION,
    UPDATE_MAKE_REQUEST_QUOTAS,
    UPDATE_SALE_ORDER,
    UPDATE_SELECTED_QUOTA_ID,
    UPDATE_PAYMENT_METHOD,
    GENERAL_UPDATE_QUOTAS_TO_PAY,
    UPDATE_ONLINE_PAYMENT_ID,
    UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE,
    UPDATE_RESERVE_AMOUNT,
    UPDATE_SALEORDER_AT_QUOTAS_TO_PAY
} from "./actionConst";

import { NONE, RESERVE, COMPLETE_QUOTA } from 'constants/draftSaleOrderPaymentTypeConst';

const initialState = {
    quotas: [],
    quotasDetail: [],
    totalToPay: 0,
    makeRequestQuotas: true,
    saleOrder: {
        id: 0,
        name: "",
        status: "",
        zeroInitialQuota: false
    },
    selectedQuotaId: 0,
    paymentMethod: null,
    onlinePaymentId: 0,
    draftSaleOrderPaymentType: NONE,
    reserveAmount: 0
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_QUOTASTOPAY:
            let newSelectedQuotaId = state.selectedQuotaId;
            let newTotalToPay = { value: 0 };
            let newQuotas = clearQuotasToPaySelection(action.payload);
            let newQuotasDetail = [];
            if (state.selectedQuotaId != 0 &&
                quotaIdExistsInQuotas(newQuotas, state.selectedQuotaId)) {
                console.log("quotaIdExistsInQuotas :", newQuotas, state.selectedQuotaId);
                newQuotas = updateQuotasSelection(newQuotas, state.selectedQuotaId, newTotalToPay);
                newQuotasDetail = newQuotas.filter(quota => quota.selected == true).map(quota => { quota.futureBalance = 0; return quota; });
            } else {
                newSelectedQuotaId = 0;
            }
            return {
                ...state,
                totalToPay: newTotalToPay.value,
                quotas: newQuotas,
                selectedQuotaId: newSelectedQuotaId,
                quotasDetail: newQuotasDetail
            }
        case UPDATE_QUOTAS_SELECTION: {
            let newTotalToPay = { value: 0 };
            let newQuotas = updateQuotasSelection(state.quotas, action.payload, newTotalToPay);
            let newQuotasDetail = newQuotas.filter(quota => quota.selected == true).map(quota => { quota.futureBalance = 0; return quota; });
            return {
                ...state,
                quotas: newQuotas,
                totalToPay: newTotalToPay.value,
                quotasDetail: newQuotasDetail,
                selectedQuotaId: action.payload
            }
        }
        case UPDATE_MAKE_REQUEST_QUOTAS: {
            return {
                ...state,
                makeRequestQuotas: action.payload
            }
        }
        case UPDATE_SALE_ORDER: {
            return {
                ...state,
                saleOrder: Object.assign({}, action.payload)
            }
        }
        case UPDATE_SELECTED_QUOTA_ID: {
            return {
                ...state,
                selectedQuotaId: action.payload
            }
        }
        case UPDATE_PAYMENT_METHOD: {
            let newPaymentMethod = Object.assign({}, action.payload.paymentMethod);
            let accountBalance = action.payload.accountBalance;
            let newTotalToPay = 0;

            if (newPaymentMethod.name === "CUENTA") {
                state.quotasDetail.forEach(function (quotaDetail) {

                    if (state.draftSaleOrderPaymentType === RESERVE) {
                        if (accountBalance >= state.reserveAmount) {
                            quotaDetail.futureBalance = quotaDetail.currentBalance - state.reserveAmount;
                            accountBalance = accountBalance - state.reserveAmount;
                        } else {
                            quotaDetail.futureBalance = quotaDetail.currentBalance;
                        }
                    } else {
                        if (accountBalance >= quotaDetail.currentBalance) {
                            quotaDetail.futureBalance = 0;
                            accountBalance = accountBalance - quotaDetail.currentBalance;
                        } else {
                            if (accountBalance > 0) {
                                quotaDetail.futureBalance = quotaDetail.currentBalance - accountBalance;
                                accountBalance = 0;
                            } else {
                                quotaDetail.futureBalance = quotaDetail.currentBalance;
                            }
                        }
                    }

                });
            } else {
                if (state.draftSaleOrderPaymentType !== RESERVE) {
                    state.quotasDetail.map(quotaDetail => { quotaDetail.futureBalance = 0; return quotaDetail });
                }
            }

            if (state.draftSaleOrderPaymentType === RESERVE) {
                newTotalToPay = state.reserveAmount;
            } else {
                newTotalToPay = state.quotasDetail.reduce(function (acumulator, quotaDetail) {
                    return acumulator + (quotaDetail.currentBalance - quotaDetail.futureBalance)
                }, 0);
            }

            return {
                ...state,
                paymentMethod: newPaymentMethod,
                quotasDetail: state.quotasDetail.slice(),
                totalToPay: newTotalToPay
            }
        }
        case GENERAL_UPDATE_QUOTAS_TO_PAY:
            return action.payload
        case UPDATE_ONLINE_PAYMENT_ID: {
            return {
                ...state,
                onlinePaymentId: action.payload
            }
        }
        case UPDATE_DRAFT_SALEORDER_PAYMENT_TYPE: {
            let newTotalToPay = { value: 0 };
            let newQuotas = updateQuotaSelectionForDraftSaleOrder(state.quotas,
                action.payload.paymentType,
                action.payload.reserveAmount,
                newTotalToPay);
            let newQuotasDetail = newQuotas.filter(quota => quota.selected == true).map(quota => { return quota; });
            return {
                ...state,
                quotas: newQuotas,
                quotasDetail: newQuotasDetail,
                totalToPay: newTotalToPay.value,
                draftSaleOrderPaymentType: action.payload.paymentType
            }
        }
        case UPDATE_RESERVE_AMOUNT: {
            return {
                ...state,
                reserveAmount: action.payload
            }
        }

        case UPDATE_SALEORDER_AT_QUOTAS_TO_PAY: {
            const newSaleOrders = action.payload;            
            const filteredSaleOrders = newSaleOrders.filter(saleOrder => saleOrder.value == state.saleOrder.id);
            let newSaleOrder = Object.assign({}, state.saleOrder);
            if (filteredSaleOrders.length > 0) {
                newSaleOrder.status = filteredSaleOrders[0].status;
            }
            return {
                ...state,
                saleOrder: newSaleOrder
            }
        }

        default:
            return state;
    }
}

function clearQuotasToPaySelection(payload) {
    let newQuotas = payload;
    newQuotas.map(function (quota) {
        quota.selected = false;
    });
    return newQuotas;
}

function updateQuotaSelectionForDraftSaleOrder(stateQuotas, paymentType, reserveAmount, newTotalToPay) {
    console.log("stateQuotas", stateQuotas, paymentType);
    let quotas = stateQuotas.slice();
    let newQuotas = quotas.map(function (quota) {
        switch (paymentType) {
            case RESERVE:
                quota.selected = true;
                quota.futureBalance = quota.currentBalance - reserveAmount;
                newTotalToPay.value = newTotalToPay.value + reserveAmount;
                break;
            case COMPLETE_QUOTA:
                quota.selected = true;
                quota.futureBalance = 0;
                newTotalToPay.value = newTotalToPay.value + quota.currentBalance;
                break;
            case NONE:
                quota.selected = false;
                quota.futureBalance = quota.currentBalance;
                newTotalToPay.value = 0;
                break;
        }
        return quota;
    });
    return newQuotas;
}

function updateQuotasSelection(stateQuotas, quotaIdSelected, newTotalToPay) {
    let quotas = stateQuotas.slice();
    let makeSelection = true;
    let newQuotas = quotas.map(function (quota) {
        if (makeSelection) {
            quota.selected = true;
            quota.futureBalance = 0;
            newTotalToPay.value = newTotalToPay.value + quota.currentBalance;
            if (quota.id == quotaIdSelected) {
                makeSelection = false
            }
        } else {
            quota.futureBalance = quota.currentBalance;
            quota.selected = false;
        }
        return quota;
    });
    return newQuotas;
}

function quotaIdExistsInQuotas(quotas, quotaIdSelected) {
    let res = quotas.filter(quota => (quota.id === quotaIdSelected))
    return res.length > 0;
}




// WEBPACK FOOTER //
// ./src/reducers/quotastopay/quotastopayReducer.js